import { Badge } from "@/components/ui/badge";

export function DemoBadge({ className = "" }) {
  return (
    <span
      data-testid="demo-data-badge"
      className={`inline-flex items-center bg-[#222222] text-[#A1A1AA] text-[10px] font-bold px-2 py-1 rounded border border-[#333333] uppercase tracking-widest ${className}`}
    >
      Demo data
    </span>
  );
}

const CONF = {
  good: { label: "Good", cls: "bg-[#EF9F27]/15 text-[#EF9F27] border-[#EF9F27]/30" },
  moderate: { label: "Moderate", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  plan_carefully: { label: "Plan Carefully", cls: "bg-red-50 text-red-700 border-red-200" },
};

export function ConfidenceBadge({ level }) {
  const c = CONF[level] || CONF.moderate;
  return (
    <Badge
      data-testid="confidence-badge"
      className={`rounded-full border px-3 py-1 text-sm font-bold ${c.cls}`}
    >
      {c.label}
    </Badge>
  );
}
